import { render, staticRenderFns } from "./FinishedHistoryList.vue?vue&type=template&id=1b80ad0c&scoped=true&"
import script from "./FinishedHistoryList.vue?vue&type=script&lang=js&"
export * from "./FinishedHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./FinishedHistoryList.vue?vue&type=style&index=0&id=1b80ad0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80ad0c",
  null
  
)

export default component.exports